import Order from './Order.component';

export default Order;
